module.exports = __webpack_public_path__ + "img/thumbnail-header-9.6a54ba8.jpeg";